
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { GetOrganizationTransactionByIdDto } from 'src/app/core/api/models/get-organization-transaction-by-id-dto';
import { GetEnumValuesDto } from 'src/app/core/api/models';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { BaseOrganizationTransactionsDetailComponent } from "../../organization-transactions/base-organization-transactions-detail/base-organization-transactions-detail.component";


@Component({
    selector: 'app-resellers-organization-transactions-detail',
    templateUrl: './resellers-organization-transactions-detail.component.html',
    imports: [BaseIndexModule, BaseOrganizationTransactionsDetailComponent]
})
export class ResellersOrganizationTransactionsDetailComponent implements OnInit {


  //#region Properties

  @Input("model") model: GetOrganizationTransactionByIdDto;
  @Input() TypeCreditChangesEnumValues: GetEnumValuesDto[];
  @Input() TypeTransactionsEnumValues: GetEnumValuesDto[];
  @Output("closePage") output_closPage = new EventEmitter<boolean>();

  //#endregion

  constructor() {
  }
  
  ngOnInit() {    
  }

  //#endregion

  onClose() {
    this.output_closPage.emit(true);
  }


}
